import React, { useLayoutEffect } from 'react'
import createPersistedState from 'use-persisted-state'

import Postman from './Postman'

import { selectContent } from '~utils/analytics'

const loadPostman = (envTitle, credentials, anonymous) => {
  (function (p,o,s,t,m,a,n) {
    !p[s] && (p[s] = function () { (p[t] || (p[t] = [])).push(arguments) })

    !o.getElementById(s+t) && o.getElementsByTagName('head')[0].appendChild((
      (n = o.createElement('script')),
      (n.id = s+t), (n.async = 1), (n.src = m), n
    ))

    if (!anonymous) { setupCredentials(envTitle, credentials) }
  }(window, document, '_pm', 'PostmanRunObject', 'https://run.pstmn.io/button.js'))
}

// Remove all known Postman objects when the element is unloaded
const unloadPostman = () => {
  const element = document.getElementById('_pmPostmanRunObject')
  element && element.remove()

  const overlay = document.getElementById('pm-oip-overlay')
  overlay && overlay.remove()

  window && window._pm && delete window._pm
  window && window.PostmanRunObject && delete window.PostmanRunObject
}

const setupCredentials = (envTitle, credentials) => {
  window._pm('env.create', envTitle, credentials)
}

const Component = ({
  id = 'default',
  env = 'credentials',
  envtitle: envTitle = 'Box',
  anonymous
}) => {
  id = (id === 'default') ? process.env.GATSBY_POSTMAN_DEFAULT_COLLECTION_ID : id
  anonymous = ['', 'true', true].includes(anonymous)
  
  const useCredentials = createPersistedState(`com.box.developer.${env}`)
  const useClientId = createPersistedState(`com.box.developer.${env}.client_id`)
  const useClientSecret = createPersistedState(`com.box.developer.${env}.client_secret`)
  
  const [credentials] = useCredentials({})
  const [clientId] = useClientId('')
  const [clientSecret] = useClientSecret('')

  envTitle = `${envTitle} (${credentials.login})`

  useLayoutEffect(() => {
    loadPostman(envTitle,
      { 
        access_token: credentials.access_token,
        refresh_token: credentials.refresh_token,
        expires_at: credentials.expires_at,
        enable_auto_refresh_access_token: true,
        client_id: clientId,
        client_secret: clientSecret,
        user_id: credentials.user_id,
        enterprise_id: credentials.enterprise_id
      },
      anonymous
    )

    return unloadPostman
  }, [])

  /**
   * Register that the user clicked this item with Google
   */
  const onClick = () => {
    const message = `Load Postman collection (${anonymous ? 'Anonymous' : 'Authenticated'})`
    selectContent(message)
  }

  return (
    <Postman id={id} onClick={onClick} />
  )
}

export default Component